import { put, takeLatest, all } from "redux-saga/effects";
import * as Actions from "../../actions/billing/billing";
import { getCurrentBillCall, getQuickBillCall } from "../../../api/billing/index";
import { getContractAccountCall } from "../../../api/account/index";
import { setAlertState, getAlertState } from "../../../util/util";

export function* getCurrentBill({ billId, callback }) {
  try {
    const response = yield getCurrentBillCall(billId);

    yield put(Actions.getCurrentBillSuccess(response));
    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    if (callback) {
      callback({ error });
    }
    yield put(Actions.getCurrentBillFailure(error));
  }
}

export function* getQuickBill({ contractAccountNumber, callback }) {
  try {
    let responseData = yield getQuickBillCall(contractAccountNumber);
    if (responseData) {
      if (responseData?.data?.data?.length !== 0) {
        getAlertState() && setAlertState(false);
        yield put(Actions.getQuickBillSuccess(responseData, responseData?.data?.data[0]?.currencySymbol));
        callback?.(responseData.data);
      } else {
        callback({});
      }
    } else {
      yield put(Actions.resetQuickBill());
      callback?.(null);
    }
  } catch (error) {
    // Handle the error, e.g., log it for debugging
    console.error("Error in getQuickBill saga:", error);
    yield put(Actions.resetQuickBill());
    callback?.(null);
  }
}

export function* getContractAccount({ billId, callback }) {
  try {
    let reqBody = {
      accountId: billId,
    };
    const response = yield getContractAccountCall(reqBody);
    yield put(Actions.getContractAccountSuccess(response));
    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    if (callback) {
      callback({ error });
    }
    yield put(Actions.getContractAccountFailure(error));
  }
}

export default function* billingWatcher() {
  yield all([takeLatest(Actions.GETCURRENTBILL, getCurrentBill), takeLatest(Actions.GETQUICKBILL, getQuickBill)]);
}
